<!-- A headline figure with its trend: Units, Volume, and the like. -->
<template>
  <div class="ins-card">
    <p class="ins-kpi__label">{{ label }}</p>
    <div v-if="loading" class="ins-skel" aria-hidden="true" style="margin-top:10px"><span style="width:60%;height:26px"></span><span style="width:40%"></span></div>
    <template v-else>
      <div class="ins-kpi__value">{{ display }}</div>
      <div class="ins-kpi__foot">
        <TrendDelta v-if="prev !== null && prev !== undefined" :cur="value" :prev="prev" :format="format" :lower-is-better="lowerIsBetter" :label="trendLabel" />
        <span v-if="note">{{ note }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import TrendDelta from './TrendDelta.vue'
import { formatAs } from '@/helpers/insights/insightMath.js'

export default {
  name: 'KpiTile',
  components: { TrendDelta },
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: null },
    prev: { type: [Number, String], default: null },
    // 'curc' (compact currency) suits a tile. Tables use 'cur'.
    format: { type: String, default: 'int' },
    note: { type: String, default: '' },
    trendLabel: { type: String, default: 'Trend window' },
    lowerIsBetter: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    display() { return formatAs(this.value, this.format) }
  }
}
</script>
